import './config/startup';

import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
// import './index.css';
// import './utils/I18n';
// import './utils/Currencies';
import App from './components/App';
// import * as serviceWorker from './serviceWorker';

try {
	// const tagManagerArgs = {
	// 	gtmId: process.env.GTM_CONTAINER_ID,
	// };
	// TagManager.initialize(tagManagerArgs);

	// Sentry.init({
	// 	dsn:
	// 		'https://1a9f4fd9af324b73982dcca17e11f88c@o141187.ingest.sentry.io/5972567',
	// 	integrations: [new Integrations.BrowserTracing()],

	// 	// Set tracesSampleRate to 1.0 to capture 100%
	// 	// of transactions for performance monitoring.
	// 	// We recommend adjusting this value in production
	// 	tracesSampleRate: 1.0,
	// });

	ReactDOM.render(<App />, document.getElementById('root'));

	console.debug(
		`%c 🍦 1.${process.env.CIRCLE_BUILD_NUM} `,
		'color: white; background: #5956D7; border-radius: 5px'
	);

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: http://bit.ly/CRA-PWA
	// serviceWorker.unregister();
} catch (e) {
	Sentry.captureException(e);
}
